/* Publish by EComposer at 2026-10-07 16:14:19*/
;try{
 (function () {
  'use strict';
  if (window.__astroyaRkmBoot) { return; }

  var API = 'https://n8n.astroya.fr/webhook/relation-karmique';
  var TOKEN_KEY = 'astroya_rk_token';
  var EMAIL_KEY = 'astroya_rk_email';
  var RIT_KEY = 'astroya_rk_rituel';
  var COOKIE_DAYS = 400;

  /* Textes du test uniquement : le calcul est dans n8n */
  var QUESTIONS = [{"q":"Comment a commenc\u00e9 cette relation\u00a0?","o":["Un coup de foudre imm\u00e9diat, comme des retrouvailles","Tr\u00e8s vite, presque trop vite","Doucement, puis tout s'est emball\u00e9","Je ne sais plus, tout est flou"]},{"q":"Quand l'autre s'\u00e9loigne, m\u00eame un peu, tu ressens\u2026","o":["Une panique\u00a0: j'ai peur qu'il ou elle ne revienne pas","De la col\u00e8re\u00a0: j'ai besoin de savoir ce qui se passe","Je redouble d'efforts pour lui faire plaisir","Un certain soulagement, je respire"]},{"q":"Vos disputes ressemblent \u00e0\u2026","o":["Toujours la m\u00eame, sur les m\u00eames sujets","Une lutte de pouvoir\u00a0: qui aura le dernier mot","Je c\u00e8de pour que la paix revienne","J'ai parfois peur de sa r\u00e9action"]},{"q":"Cette relation te rappelle\u2026","o":["Le couple de mes parents","Mes histoires d'amour pr\u00e9c\u00e9dentes","Un d\u00e9j\u00e0-v\u00e9cu ailleurs, autrement, comme une autre vie","Rien de connu, c'est totalement nouveau"]},{"q":"Sans cette personne, tu te sens\u2026","o":["Incompl\u00e8te, comme amput\u00e9e d'une partie de moi","Perdue, sans rep\u00e8res","Libre, mais coupable de l'\u00eatre","Bien, au fond"]},{"q":"Dans ce lien, qui donne le plus\u00a0?","o":["Moi, toujours moi","\u00c7a d\u00e9pend des jours\u00a0: on alterne le chaud et le froid","Je d\u00e9cide, l'autre suit","C'est plut\u00f4t \u00e9quilibr\u00e9"]},{"q":"Que voudrais-tu le plus aujourd'hui\u00a0?","o":["Comprendre pourquoi je revis toujours la m\u00eame histoire","Ne plus avoir peur de perdre l'autre","Retrouver ma libert\u00e9","Que l'autre change enfin"]}];

  /* 72 anges : nom | jour | mois de debut | vertu (pages en ligne : 1 a 42) */
  var ANGELS = ["Vehuiah|21|3|Volont\u00e9 & nouveaux commencements","Jeliel|26|3|Amour & fid\u00e9lit\u00e9 du couple","Sitael|31|3|Construction & protection","Elemiah|5|4|Travail & voyages int\u00e9rieurs","Mahasiah|10|4|Paix int\u00e9rieure & harmonie","Lelahel|15|4|Lumi\u00e8re & gu\u00e9rison","Achaiah|21|4|Patience & secrets de la nature","Cahetel|26|4|B\u00e9n\u00e9diction & abondance","Haziel|1|5|Pardon & mis\u00e9ricorde","Aladiah|6|5|Gr\u00e2ce & r\u00e9g\u00e9n\u00e9ration","Lauviah|11|5|Victoire & gratitude","Hahaiah|16|5|R\u00eaves & intuition","Iezalel|21|5|R\u00e9conciliation & fid\u00e9lit\u00e9","Mebahel|26|5|V\u00e9rit\u00e9 & justice","Hariel|1|6|Purification & foi","Hakamiah|6|6|Loyaut\u00e9 & noblesse","Lauviah|11|6|Sommeil & r\u00e9v\u00e9lation","Caliel|16|6|Justice & int\u00e9grit\u00e9","Leuviah|22|6|M\u00e9moire & gr\u00e2ce","Pahaliah|27|6|Vocation & r\u00e9demption","Nelchael|2|7|Connaissance & \u00e9tudes","Yeiayel|7|7|Renomm\u00e9e & voyages","Melahel|12|7|Gu\u00e9rison & plantes","Haheuiah|17|7|Protection & refuge","Nith-Haiah|23|7|Sagesse & \u00e9sot\u00e9risme","Haaiah|28|7|Diplomatie & ambition","Yerathel|2|8|Lumi\u00e8re & savoir","Seheiah|7|8|Sant\u00e9 & long\u00e9vit\u00e9","Reiyel|13|8|Lib\u00e9ration & foi","Omael|18|8|Fertilit\u00e9 & abondance","Lecabel|23|8|Talent & r\u00e9ussite","Vasariah|29|8|Cl\u00e9mence & \u00e9loquence","Yehuiah|3|9|Loyaut\u00e9 & ordre","Lehahiah|8|9|Calme & discipline","Chavakhiah|13|9|Harmonie familiale","Menadel|18|9|Travail & vocation","Aniel|24|9|Rompre le cercle","Haamiah|29|9|Rituels & v\u00e9rit\u00e9","Rehael|4|10|Gu\u00e9rison & respect","Ieiazel|9|10|Consolation & arts","Hahahel|14|10|Mission spirituelle","Mikael|19|10|Ordre & providence","Veuliah|24|10|Prosp\u00e9rit\u00e9 & paix","Yelahiah|29|10|Courage & succ\u00e8s","Sealiah|3|11|Motivation & vitalit\u00e9","Ariel|8|11|Perception & gratitude","Asaliah|13|11|Contemplation & v\u00e9rit\u00e9","Mihael|18|11|Amour & f\u00e9condit\u00e9","Vehuel|23|11|Grandeur & g\u00e9n\u00e9rosit\u00e9","Daniel|28|11|\u00c9loquence & d\u00e9cision","Hahasiah|3|12|M\u00e9decine universelle","Imamiah|8|12|R\u00e9paration & libert\u00e9","Nanael|13|12|M\u00e9ditation & \u00e9tudes","Nithael|17|12|Stabilit\u00e9 & gr\u00e2ce","Mebahiah|22|12|Lucidit\u00e9 & transmission","Poyel|27|12|Fortune & v\u0153ux","Nemamiah|1|1|Discernement & prosp\u00e9rit\u00e9","Yeialel|6|1|Force mentale & courage","Harahel|11|1|Connaissance & richesse","Mitzrael|16|1|R\u00e9paration & gu\u00e9rison","Umabel|21|1|Amiti\u00e9 & affinit\u00e9s","Iah-Hel|26|1|S\u00e9r\u00e9nit\u00e9 & sagesse","Anauel|31|1|Unit\u00e9 & protection","Mehiel|5|2|Inspiration & \u00e9criture","Damabiah|10|2|Succ\u00e8s & abondance","Manakel|15|2|Apaisement & sommeil","Eyael|20|2|Consolation & long\u00e9vit\u00e9","Habuhiah|25|2|Gu\u00e9rison & fertilit\u00e9","Rochel|2|3|Restitution & justice","Jabamiah|7|3|R\u00e9g\u00e9n\u00e9ration & alchimie","Haiaiel|12|3|Courage & victoire","Mumiah|17|3|Renaissance & accomplissement"];
  var CHOIRS = [
    ["S\u00e9raphins", "l'\u00e9lan pour repartir \u00e0 neuf et oser enfin choisir pour toi."],
    ["Ch\u00e9rubins", "la sagesse de comprendre et la force de pardonner sans t'oublier."],
    ["Tr\u00f4nes", "la m\u00e9moire de ta propre valeur et la justice envers toi-m\u00eame."],
    ["Dominations", "la clart\u00e9 pour sortir des influences qui ne te ressemblent plus."],
    ["Puissances", "la discipline des limites et le courage de rompre les cercles."],
    ["Vertus", "le courage de suivre ta mission plut\u00f4t que la peur de perdre."],
    ["Principaut\u00e9s", "la d\u00e9cision juste et la libert\u00e9 retrouv\u00e9e."],
    ["Archanges", "le discernement pour reconna\u00eetre les liens qui te font grandir."],
    ["Anges", "l'apaisement et la renaissance apr\u00e8s la fin d'un cycle."]
  ];
  var MONTHS = ["janvier", "f\u00e9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\u00fbt", "septembre", "octobre", "novembre", "d\u00e9cembre"];
  var MLEN = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  /* Messages de liberation du jour (rituel) */
  var RIT_MSG = [
    ["Je garde la le\u00e7on, je rends le lien.", "Aujourd'hui, \u00e9cris en une phrase ce que cette relation t'a appris sur toi."],
    ["Ce qui se r\u00e9p\u00e8te en moi peut s'arr\u00eater avec moi.", "Rep\u00e8re une r\u00e9action automatique aujourd'hui, et fais exactement l'inverse, une seule fois.", "Aniel", "/pages/aniel-ange-gardien"],
    ["Je pardonne pour \u00eatre libre, pas pour revenir.", "Pense \u00e0 l'autre trois secondes, souhaite-lui du bien, puis reviens \u00e0 ta journ\u00e9e.", "Haziel", "/pages/haziel-ange-gardien"],
    ["Mon \u00e9nergie m'appartient de nouveau.", "Offre-toi une heure rien qu'\u00e0 toi\u00a0: marche, bain, musique, sans \u00e9cran."],
    ["Je n'ai pas besoin d'\u00eatre choisie pour \u00eatre pr\u00e9cieuse.", "Note trois qualit\u00e9s que tu reconnais en toi, sans fausse modestie."],
    ["La page se tourne, l'histoire continue.", "Range un objet qui te ram\u00e8ne \u00e0 cette relation, sans le jeter\u00a0: juste hors de ta vue.", "Aladiah", "/pages/aladiah-ange-gardien"],
    ["Je choisis la paix plut\u00f4t que l'intensit\u00e9.", "Remarque aujourd'hui ce qui te calme vraiment, et fais-en plus."],
    ["Les liens qui me font grandir n'exigent pas que je me perde.", "Appelle une personne qui te fait du bien, simplement pour prendre des nouvelles."],
    ["Je romps le silence du pass\u00e9, je retrouve ma voix.", "Dis \u00e0 voix haute une limite que tu n'as jamais os\u00e9 formuler.", "Mebahel", "/pages/mebahel-ange-gardien"],
    ["Ma s\u00e9curit\u00e9 vient de l'int\u00e9rieur.", "Pose la main sur ton c\u0153ur, respire lentement sept fois, et r\u00e9p\u00e8te\u00a0: je suis l\u00e0.", "Haheuiah", "/pages/haheuiah-ange-gardien"],
    ["Ce lien m'a transform\u00e9e, il ne me d\u00e9finit pas.", "\u00c9cris la personne que tu deviens, au pr\u00e9sent, en cinq lignes."],
    ["Je lib\u00e8re l'autre, et je me lib\u00e8re.", "Ce soir, allume une bougie et souffle-la en formulant ton intention de libert\u00e9."]
  ];

  /* ---------- Utilitaires ---------- */
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { } }
  function ckGet(k) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].replace(/^\s+/, '');
        if (p.indexOf(k + '=') === 0) { return decodeURIComponent(p.substring(k.length + 1)); }
      }
    } catch (e) { }
    return null;
  }
  function ckSet(k, v) {
    try {
      var dom = /(^|\.)astroya\.fr$/i.test(window.location.hostname) ? ';domain=.astroya.fr' : '';
      var sec = window.location.protocol === 'https:' ? ';Secure' : '';
      document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=' + (COOKIE_DAYS * 86400) + dom + ';SameSite=Lax' + sec;
    } catch (e) { }
  }
  function ckDel(k) {
    try {
      var dom = /(^|\.)astroya\.fr$/i.test(window.location.hostname) ? ';domain=.astroya.fr' : '';
      document.cookie = k + '=;path=/;max-age=0' + dom;
    } catch (e) { }
  }
  function getToken() { return lsGet(TOKEN_KEY) || ckGet(TOKEN_KEY) || ''; }
  function setToken(t) { lsSet(TOKEN_KEY, t); ckSet(TOKEN_KEY, t); }
  function clearToken() { try { window.localStorage.removeItem(TOKEN_KEY); } catch (e) { } ckDel(TOKEN_KEY); }
  function isUnlocked() { return !!getToken(); }
  function buzz(p) { try { if (navigator.vibrate) { navigator.vibrate(p); } } catch (e) { } }
  function hasClass(el, c) { return (' ' + el.className + ' ').indexOf(' ' + c + ' ') > -1; }
  function addClass(el, c) { if (!hasClass(el, c)) { el.className = (el.className + ' ' + c).replace(/^\s+/, ''); } }
  function rmClass(el, c) { el.className = (' ' + el.className + ' ').replace(' ' + c + ' ', ' ').replace(/^\s+|\s+$/g, ''); }

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { }

  /* ---------- Appel du webhook n8n ---------- */
  function api(payload, cb) {
    payload.token = getToken();
    payload.page = 'relation-karmique';
    if (window.__rkmMock) { window.__rkmMock(payload, cb); return; }
    try {
      var x = new XMLHttpRequest();
      x.open('POST', API, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.timeout = 15000;
      x.onreadystatechange = function () {
        if (x.readyState !== 4) { return; }
        if (x.status >= 200 && x.status < 300) {
          var d = null;
          try { d = JSON.parse(x.responseText); } catch (e) { d = null; }
          cb(d && typeof d === 'object' ? d : { ok: false });
        } else { cb({ ok: false }); }
      };
      x.onerror = function () { cb({ ok: false }); };
      x.ontimeout = function () { cb({ ok: false }); };
      x.send(JSON.stringify(payload));
    } catch (er) { cb({ ok: false }); }
  }

  /* ---------- Moteur des fils lumineux (canvas) ----------
     tight = 1 : les deux fils s'enroulent en noeud au centre ; tight = 0 : ils se separent et ondulent librement */
  function Threads(cv, o) {
    var self = this;
    var ctx = cv.getContext ? cv.getContext('2d') : null;
    if (!ctx) { return; }
    o = o || {};
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, t0 = 0, last = 0, running = false, visible = true, raf = 0;
    var parts = [], stars = [];
    self.tight = o.tight === undefined ? 1 : o.tight;
    self.target = self.tight;
    self.ease = o.ease || 0.06;
    self.pointer = null;
    var lw = o.lw || 2.2;
    var turns = o.turns || 3.2;
    var spread = o.spread || 0.24;
    var sepF = o.sep || 0.2;
    var ampF = o.amp || 0.16;

    function size() {
      var r = cv.getBoundingClientRect();
      W = Math.max(10, Math.round(r.width * dpr));
      H = Math.max(10, Math.round(r.height * dpr));
      cv.width = W; cv.height = H;
      if (o.stars) {
        stars = [];
        for (var i = 0; i < 60; i++) { stars.push([Math.random() * W, Math.random() * H, Math.random() * 1.3 + 0.3, Math.random() * 6.28]); }
      }
    }

    function curve(time, k0) {
      var A = [], B = [], step = 3 * dpr, cx = W / 2, cy = H / 2;
      var sep = H * sepF, amp = H * ampF;
      for (var x = -step; x <= W + step; x += step) {
        var u = (x - cx) / W;
        var env = Math.exp(-(u / spread) * (u / spread));
        var k = k0 * env;
        var arg = u * 6.2832 * turns + time * 0.0011;
        var wav = Math.sin(x / W * 6.2832 * 1.1 + time * 0.0007) * H * 0.04;
        var tw = Math.sin(arg) * amp * (0.35 + 0.65 * k);
        var yA = cy + (-sep) * (1 - k) + wav + tw * k + Math.sin(x / W * 9 + time * 0.0013) * H * 0.012 * (1 - k);
        var yB = cy + sep * (1 - k) - wav * 0.7 - tw * k + Math.cos(x / W * 8 + time * 0.0012) * H * 0.012 * (1 - k);
        var z = Math.cos(arg);
        A.push([x, yA, z * k]);
        B.push([x, yB, -z * k]);
      }
      return [A, B];
    }

    function strokeRuns(P, front, color, width, alpha) {
      ctx.strokeStyle = color; ctx.lineWidth = width; ctx.globalAlpha = alpha;
      ctx.beginPath();
      var open = false;
      for (var i = 0; i < P.length - 1; i++) {
        var f = (P[i][2] + P[i + 1][2]) / 2 >= 0;
        if (f === front) {
          if (!open) { ctx.moveTo(P[i][0], P[i][1]); open = true; }
          ctx.lineTo(P[i + 1][0], P[i + 1][1]);
        } else { open = false; }
      }
      ctx.stroke();
    }

    function drawThread(P, front, c1, c2) {
      strokeRuns(P, front, c1, lw * 4.5 * dpr, 0.1);
      strokeRuns(P, front, c1, lw * 2 * dpr, 0.3);
      strokeRuns(P, front, c2, lw * dpr, 0.95);
    }

    function emit(n, x, y, burst) {
      for (var i = 0; i < n; i++) {
        var a = Math.random() * 6.2832, sp = burst ? (Math.random() * 3 + 1) * dpr : (Math.random() * 0.5 + 0.1) * dpr;
        parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - (burst ? 0 : 0.25 * dpr), life: 1, d: burst ? 0.012 + Math.random() * 0.012 : 0.008 + Math.random() * 0.01, r: (Math.random() * 1.8 + 0.6) * dpr, c: Math.random() < 0.5 ? '#ffd9a0' : '#c9c4ff' });
      }
      if (parts.length > 220) { parts.splice(0, parts.length - 220); }
    }

    self.burst = function () { emit(90, W / 2, H / 2, true); };

    function frame(now) {
      if (!running) { return; }
      raf = window.requestAnimationFrame(frame);
      if (!visible) { return; }
      if (!t0) { t0 = now; }
      var dt = Math.min(48, now - (last || now)); last = now;
      var time = reduceMotion ? 0 : now - t0;
      var tgt = self.target;
      if (o.interactive && self.pointer) {
        var dx = self.pointer[0] - W / 2, dy = self.pointer[1] - H / 2;
        var prox = Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) / (W * 0.42));
        tgt = tgt * (1 - 0.85 * prox);
      }
      self.tight += (tgt - self.tight) * Math.min(1, self.ease * dt / 16);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, W, H);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      if (stars.length) {
        for (var s = 0; s < stars.length; s++) {
          var st = stars[s];
          ctx.globalAlpha = 0.25 + 0.35 * (0.5 + 0.5 * Math.sin(time * 0.0012 + st[3]));
          ctx.fillStyle = '#ffffff';
          ctx.beginPath(); ctx.arc(st[0], st[1], st[2] * dpr, 0, 6.2832); ctx.fill();
        }
      }
      var c = curve(time, self.tight);
      drawThread(c[0], false, '#f0a75a', '#ffdcaa');
      drawThread(c[1], false, '#8f8ae6', '#dcd9ff');
      drawThread(c[0], true, '#f0a75a', '#ffdcaa');
      drawThread(c[1], true, '#8f8ae6', '#dcd9ff');
      /* coeur du noeud */
      if (self.tight > 0.05) {
        var g = ctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, H * 0.32);
        g.addColorStop(0, 'rgba(255,214,160,' + (0.32 * self.tight).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(255,214,160,0)');
        ctx.globalAlpha = 1; ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);
      }
      if (!reduceMotion && Math.random() < (o.sparks || 0.25)) {
        var P = Math.random() < 0.5 ? c[0] : c[1];
        var q = P[Math.floor(P.length * (0.3 + Math.random() * 0.4))];
        emit(1, q[0], q[1], false);
      }
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        p.x += p.vx * dt / 16; p.y += p.vy * dt / 16; p.vx *= 0.985; p.vy *= 0.985; p.life -= p.d * dt / 16;
        if (p.life <= 0) { parts.splice(i, 1); continue; }
        ctx.globalAlpha = p.life; ctx.fillStyle = p.c;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832); ctx.fill();
      }
      /* fondu sur les bords */
      if (o.fade !== false) {
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = 'destination-in';
        var m = ctx.createLinearGradient(0, 0, W, 0);
        m.addColorStop(0, 'rgba(0,0,0,0)'); m.addColorStop(0.12, 'rgba(0,0,0,1)');
        m.addColorStop(0.88, 'rgba(0,0,0,1)'); m.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = m; ctx.fillRect(0, 0, W, H);
        ctx.globalCompositeOperation = 'source-over';
      }
      ctx.globalAlpha = 1;
    }

    self.start = function () { if (!running) { running = true; last = 0; raf = window.requestAnimationFrame(frame); } };
    size();
    window.addEventListener('resize', function () { size(); });
    if (o.interactive) {
      var host = o.interactive;
      var mv = function (e) {
        var r = cv.getBoundingClientRect(), pt = e.touches && e.touches[0] ? e.touches[0] : e;
        self.pointer = [(pt.clientX - r.left) * dpr, (pt.clientY - r.top) * dpr];
        if (o.onPoint) { o.onPoint(); }
      };
      host.addEventListener('mousemove', mv);
      host.addEventListener('touchmove', mv, { passive: true });
      host.addEventListener('touchstart', mv, { passive: true });
      host.addEventListener('mouseleave', function () { self.pointer = null; });
      host.addEventListener('touchend', function () { self.pointer = null; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) { last = 0; } }, { rootMargin: '80px' }).observe(cv);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) { running = false; window.cancelAnimationFrame(raf); } else { self.start(); } });
    self.start();
  }

  /* ---------- Hero ---------- */
  function initHero() {
    var cv = $('rkm-hero-cv'), orb = $('rkm-orb');
    if (!cv || !orb) { return; }
    var hint = $('rkm-orb-hint'), hidden = false;
    new Threads(cv, { tight: 1, stars: true, interactive: orb, sparks: 0.45, turns: 4.2, spread: 0.26, sep: 0.2, amp: 0.16, lw: 2.4, ease: 0.05,
      onPoint: function () { if (!hidden && hint) { hidden = true; hint.style.opacity = '0'; } } });
  }

  /* ---------- 12 signes ---------- */
  var meterThreads = null;
  function initSigns() {
    var list = $('rkm-signs');
    if (!list) { return; }
    var cards = list.querySelectorAll('.rkm-sign');
    var cv = $('rkm-meter-cv');
    if (cv) { meterThreads = new Threads(cv, { tight: 0, turns: 3.6, spread: 0.3, sep: 0.24, amp: 0.22, lw: 1.6, sparks: 0.2, ease: 0.08 }); }
    var msgs = [
      [0, "Coche les signes que tu reconnais."],
      [1, "Quelques fils se croisent. Rien d'alarmant, mais reste attentive."],
      [4, "Le n\u0153ud se forme\u00a0: plusieurs signes d'un lien karmique apparaissent."],
      [7, "Le n\u0153ud est serr\u00e9\u00a0: ton lien a toutes les caract\u00e9ristiques d'une relation karmique."],
      [10, "Lien karmique tr\u00e8s marqu\u00e9. Le test t'aidera \u00e0 d\u00e9couvrir la le\u00e7on qu'il porte."]
    ];
    function upd() {
      var n = list.querySelectorAll('.rkm-checked').length, m = msgs[0][1];
      for (var i = 0; i < msgs.length; i++) { if (n >= msgs[i][0]) { m = msgs[i][1]; } }
      $('rkm-meter-n').textContent = String(n);
      $('rkm-meter-msg').textContent = m;
      if (meterThreads && meterThreads.ctxOk !== false) { meterThreads.target = n / 12; }
    }
    function toggle(e) {
      var c = e.currentTarget;
      if (hasClass(c, 'rkm-checked')) { rmClass(c, 'rkm-checked'); c.setAttribute('aria-checked', 'false'); }
      else { addClass(c, 'rkm-checked'); c.setAttribute('aria-checked', 'true'); buzz(12); }
      upd();
    }
    for (var k = 0; k < cards.length; k++) {
      cards[k].addEventListener('click', toggle);
      cards[k].addEventListener('keydown', function (e) { if (e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); toggle(e); } });
    }
    upd();
  }

  /* ---------- Timeline ---------- */
  function initTimeline() {
    var tl = $('rkm-tl'), fill = $('rkm-tl-fill');
    if (!tl || !fill) { return; }
    var steps = tl.querySelectorAll('.rkm-step'), ticking = false;
    function upd() {
      ticking = false;
      var r = tl.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = Math.max(0, Math.min(1, (vh * 0.62 - r.top) / Math.max(1, r.height)));
      fill.style.transform = 'scaleY(' + p.toFixed(3) + ')';
      for (var i = 0; i < steps.length; i++) {
        var sr = steps[i].getBoundingClientRect();
        if (sr.top < vh * 0.62) { addClass(steps[i], 'rkm-lit'); } else { rmClass(steps[i], 'rkm-lit'); }
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- Test ---------- */
  var quiz = { i: 0, answers: [], res: null };
  var resThreads = null;

  function renderQ() {
    var zone = $('rkm-q-zone'), Q = QUESTIONS[quiz.i];
    var h = '<div class="rkm-q-anim"><p class="rkm-q-title">' + esc(Q.q) + '</p><div class="rkm-opts">';
    for (var k = 0; k < Q.o.length; k++) {
      var picked = quiz.answers[quiz.i] === k ? ' rkm-picked' : '';
      h += '<button type="button" class="rkm-opt' + picked + '" data-k="' + k + '">' + esc(Q.o[k]) + '</button>';
    }
    h += '</div><div class="rkm-q-nav">';
    h += quiz.i > 0 ? '<button type="button" class="rkm-link-btn" id="rkm-q-back">Question pr\u00e9c\u00e9dente</button>' : '<span>&#8203;</span>';
    h += '<span>&#8203;</span></div></div>';
    zone.innerHTML = h;
    $('rkm-q-count').textContent = 'Question ' + (quiz.i + 1) + ' sur ' + QUESTIONS.length;
    $('rkm-prog').style.transform = 'scaleX(' + (quiz.i / QUESTIONS.length).toFixed(3) + ')';
    var opts = zone.querySelectorAll('.rkm-opt');
    for (var j = 0; j < opts.length; j++) { opts[j].addEventListener('click', onAnswer); }
    var back = $('rkm-q-back');
    if (back) { back.addEventListener('click', function () { quiz.i--; renderQ(); }); }
  }

  function onAnswer(e) {
    var k = parseInt(e.currentTarget.getAttribute('data-k'), 10);
    quiz.answers[quiz.i] = k;
    addClass(e.currentTarget, 'rkm-picked');
    buzz(8);
    setTimeout(function () {
      if (quiz.i < QUESTIONS.length - 1) { quiz.i++; renderQ(); }
      else { fetchResult(); }
    }, 260);
  }

  function knotBox(score) {
    return '<div class="rkm-res-knot"><canvas class="rkm-res-cv" id="rkm-res-cv" aria-hidden="true"></canvas>' +
      '<p class="rkm-res-score"><span>Lien d\u00e9nou\u00e9</span><b id="rkm-res-pct">' + (score === null ? '\u2026' : '0\u00a0%') + '</b><span>N\u0153ud serr\u00e9</span></p></div>';
  }
  function mountKnot(tight) {
    var cv = $('rkm-res-cv');
    if (!cv) { return; }
    resThreads = new Threads(cv, { tight: 0, turns: 4, spread: 0.28, sep: 0.26, amp: 0.22, lw: 1.8, sparks: 0.3, ease: 0.05 });
    setTimeout(function () { if (resThreads) { resThreads.target = tight; } }, 200);
  }
  function countUp(el, to) {
    if (!el) { return; }
    var t0 = 0;
    function f(now) {
      if (!t0) { t0 = now; }
      var p = reduceMotion ? 1 : Math.min(1, (now - t0) / 1400);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + '\u00a0%';
      if (p < 1) { window.requestAnimationFrame(f); }
    }
    window.requestAnimationFrame(f);
  }

  function renderWait() {
    $('rkm-q-count').textContent = 'Ton r\u00e9sultat';
    $('rkm-prog').style.transform = 'scaleX(1)';
    $('rkm-q-zone').innerHTML = '<div class="rkm-q-anim rkm-res-head"><p class="rkm-q-title">Les fils se d\u00e9m\u00ealent\u2026</p>' + knotBox(null) + '</div>';
    mountKnot(0.5);
  }

  function renderError(msg) {
    $('rkm-q-zone').innerHTML = '<div class="rkm-q-anim rkm-res-head"><p class="rkm-q-title">' + esc(msg) + '</p><div class="rkm-res-actions"><button type="button" class="rkm-btn" id="rkm-retry"><span class="rkm-btn-lbl">R\u00e9essayer</span></button><button type="button" class="rkm-link-btn" id="rkm-redo">Refaire le test</button></div></div>';
    $('rkm-retry').addEventListener('click', fetchResult);
    $('rkm-redo').addEventListener('click', function () { quiz.i = 0; quiz.answers = []; renderQ(); });
  }

  function fetchResult() {
    renderWait();
    api({ action: 'result', answers: quiz.answers }, function (d) {
      if (!d || !d.ok || !d.name) { renderError('Le r\u00e9sultat n\u2019a pas pu \u00eatre calcul\u00e9. V\u00e9rifie ta connexion puis r\u00e9essaie.'); return; }
      if (d.tokenValid === false) { clearToken(); }
      quiz.res = d;
      renderResult();
    });
  }

  function detailHtml(D) {
    var h = '<h3>Ce que ce lien vient t\u2019apprendre</h3><p>' + esc(D.play) + '</p>';
    h += '<h3>Trois gestes pour d\u00e9nouer</h3><ul>';
    for (var i = 0; i < (D.tips || []).length; i++) { h += '<li>' + esc(D.tips[i]) + '</li>'; }
    h += '</ul><h3>Ton ange alli\u00e9</h3>';
    if (D.angel) {
      h += '<a class="rkm-angel-box" href="' + esc(D.angel.url) + '"><span class="rkm-angel-n">' + esc(D.angel.n) + '</span><span class="rkm-ab-t"><b>' + esc(D.angel.name) + '</b>, ' + esc(D.angel.why) + ' Lire sa fiche \u2192</span></a>';
    }
    h += '<h3>Ta pierre alli\u00e9e</h3><p>' + esc(D.stone) + '</p>';
    h += '<h3>Ton affirmation de lib\u00e9ration</h3><p class="rkm-affirm">\u00ab\u00a0' + esc(D.aff) + '\u00a0\u00bb</p>';
    return h;
  }

  function placeholderHtml() {
    var p = 'Ton analyse d\u00e9taill\u00e9e appara\u00eetra ici\u00a0: ce que ce lien vient t\u2019apprendre, trois gestes concrets, ton ange alli\u00e9 et ta pierre.';
    return '<h3>Ce que ce lien vient t\u2019apprendre</h3><p>' + p + '</p><h3>Trois gestes pour d\u00e9nouer</h3><ul><li>' + p + '</li><li>' + p + '</li><li>' + p + '</li></ul><h3>Ton ange alli\u00e9</h3><p>' + p + '</p><h3>Ton affirmation</h3><p class="rkm-affirm">\u00ab\u00a0\u2026\u00a0\u00bb</p>';
  }

  function renderResult() {
    var R = quiz.res, un = !!(R.unlocked && R.detail);
    $('rkm-q-count').textContent = 'Ton r\u00e9sultat';
    $('rkm-prog').style.transform = 'scaleX(1)';
    var h = '<div class="rkm-q-anim">';
    h += '<div class="rkm-res-head"><span class="rkm-eyebrow">Ta le\u00e7on karmique</span>';
    h += '<p class="rkm-res-lesson">' + esc(R.name) + '</p>';
    h += '<p class="rkm-res-sum">' + esc(R.sum) + '</p></div>';
    h += knotBox(R.score);
    h += '<p class="rkm-res-sum" style="text-align:center">' + esc(R.band) + '</p>';
    if (R.safety) {
      h += '<div class="rkm-safety"><p><strong>Tu as indiqu\u00e9 avoir parfois peur de sa r\u00e9action.</strong> La peur n\u2019est jamais une le\u00e7on karmique. Si tu te sens en danger, parle-en\u00a0: le <a href="tel:3919">3919</a> \u00e9coute gratuitement, 24 h/24. En cas d\u2019urgence, appelle le <a href="tel:17">17</a>.</p></div>';
    }
    h += '<div class="rkm-lock' + (un ? '' : ' rkm-locked') + '" id="rkm-lock"><div class="rkm-lock-in" id="rkm-lock-in">';
    h += un ? detailHtml(R.detail) : placeholderHtml();
    h += '</div><div class="rkm-lock-veil"><p>Ton analyse compl\u00e8te t\u2019attend\u00a0: ce que ce lien vient t\u2019apprendre, 3 gestes pour le d\u00e9nouer, ton ange alli\u00e9 et ta pierre.</p><button type="button" class="rkm-btn" id="rkm-unlock"><span class="rkm-btn-lbl">D\u00e9bloquer mon analyse gratuite</span></button></div></div>';
    h += '<div class="rkm-res-actions"><button type="button" class="rkm-link-btn" id="rkm-redo">Refaire le test</button></div>';
    h += '</div>';
    $('rkm-q-zone').innerHTML = h;
    mountKnot(Math.max(0.05, Math.min(1, R.score / 100)));
    countUp($('rkm-res-pct'), parseInt(R.score, 10) || 0);
    buzz([20, 60, 30]);
    var ub = $('rkm-unlock');
    if (ub) { ub.addEventListener('click', function () { openPop('quiz'); }); }
    $('rkm-redo').addEventListener('click', function () { quiz.i = 0; quiz.answers = []; quiz.res = null; renderQ(); });
  }

  function showDetail(D) {
    var lk = $('rkm-lock'), inn = $('rkm-lock-in');
    if (!lk || !inn) { return; }
    inn.innerHTML = detailHtml(D);
    lk.className = 'rkm-lock';
    lk.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function initQuiz() { if ($('rkm-q-zone') && QUESTIONS.length) { renderQ(); } }

  /* ---------- Ange de naissance ---------- */
  var ANG = null;
  function ordinal(d, m) { var o = d; for (var i = 0; i < m - 1; i++) { o += MLEN[i]; } return o; }
  function fmt(o) { var m = 0; while (o > MLEN[m]) { o -= MLEN[m]; m++; } return [o, m]; }
  function buildAngels() {
    ANG = [];
    for (var i = 0; i < ANGELS.length; i++) {
      var a = ANGELS[i].split('|');
      var slug = '';
      if (i < 42) { slug = i === 16 ? 'lauviah-2' : a[0].toLowerCase(); }
      ANG.push({ n: i + 1, name: a[0], start: ordinal(+a[1], +a[2]), virtue: a[3], slug: slug, choir: CHOIRS[Math.floor(i / 8)] });
    }
    var sorted = ANG.slice().sort(function (x, y) { return x.start - y.start; });
    for (var j = 0; j < sorted.length; j++) {
      var nx = sorted[(j + 1) % sorted.length];
      var end = nx.start - 1; if (end < 1) { end = 366; }
      sorted[j].end = end;
    }
    return sorted;
  }
  function findAngel(d, m) {
    var sorted = buildAngels(), o = ordinal(d, m), hit = sorted[sorted.length - 1];
    for (var i = 0; i < sorted.length; i++) { if (sorted[i].start <= o) { hit = sorted[i]; } }
    return hit;
  }
  function rangeTxt(a) {
    var s = fmt(a.start), e = fmt(a.end);
    var d1 = s[0] === 1 ? '1er' : String(s[0]);
    return s[1] === e[1] ? d1 + ' - ' + e[0] + ' ' + MONTHS[e[1]] : d1 + ' ' + MONTHS[s[1]] + ' - ' + e[0] + ' ' + MONTHS[e[1]];
  }
  function initFinder() {
    var dSel = $('rkm-day'), mSel = $('rkm-month'), btn = $('rkm-find'), card = $('rkm-acard');
    if (!dSel || !mSel || !btn || !card) { return; }
    var i, op;
    for (i = 1; i <= 31; i++) { op = document.createElement('option'); op.value = String(i); op.textContent = String(i); dSel.appendChild(op); }
    for (i = 0; i < 12; i++) { op = document.createElement('option'); op.value = String(i + 1); op.textContent = MONTHS[i].charAt(0).toUpperCase() + MONTHS[i].slice(1); mSel.appendChild(op); }
    btn.addEventListener('click', function () {
      var d = parseInt(dSel.value, 10), m = parseInt(mSel.value, 10), err = $('rkm-finder-err');
      if (!d || !m) { err.textContent = 'Choisis ton jour et ton mois de naissance.'; return; }
      if (d > MLEN[m - 1]) { err.textContent = 'Cette date n\u2019existe pas\u00a0: v\u00e9rifie le jour.'; return; }
      err.innerHTML = '&#8203;';
      var a = findAngel(d, m);
      var link = a.slug ? '<a href="/pages/' + a.slug + '-ange-gardien">Lire la fiche ' + (/^[AEIOUY]/.test(a.name) && a.name !== 'Yeiayel' && a.name !== 'Yerathel' && a.name !== 'Yehuiah' && a.name !== 'Yelahiah' && a.name !== 'Yeialel' ? 'd\u2019' : 'de ') + esc(a.name) + ' \u2192</a>' : '<a href="/pages/liste-72-anges-gardiens">D\u00e9couvrir les 72 anges \u2192</a>';
      var front = '<span class="rkm-af-n">Ange n\u00b0 ' + a.n + ' \u00b7 ' + esc(a.choir[0]) + '</span><span class="rkm-af-name">' + esc(a.name) + '</span><span class="rkm-af-d">' + esc(rangeTxt(a)) + '</span><span class="rkm-af-v">' + esc(a.virtue) + '</span><p>Dans un lien karmique, ' + esc(a.name) + ' t\u2019apporte ' + esc(a.choir[1]) + '</p>' + link;
      rmClass(card, 'rkm-turned');
      addClass(card, 'rkm-shuffle');
      buzz([15, 40, 15]);
      setTimeout(function () {
        $('rkm-acard-front').innerHTML = front;
        rmClass(card, 'rkm-shuffle');
        addClass(card, 'rkm-turned');
        buzz(35);
      }, reduceMotion ? 0 : 620);
    });
  }

  /* ---------- Rituel du noeud ---------- */
  function dayKey() { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function dayMsg() {
    var d = new Date(), start = new Date(d.getFullYear(), 0, 0);
    var n = Math.floor((d - start) / 86400000);
    return RIT_MSG[n % RIT_MSG.length];
  }
  function showRitMsg(again) {
    var M = dayMsg(), box = $('rkm-rmsg');
    var h = '<div class="rkm-rmsg-in"><p class="rkm-rmsg-s">' + (again ? 'Ton message de lib\u00e9ration du jour' : 'Le n\u0153ud est d\u00e9fait. Ton message du jour\u00a0:') + '</p><p class="rkm-rmsg-q">\u00ab\u00a0' + esc(M[0]) + '\u00a0\u00bb</p><p>' + esc(M[1]) + '</p>';
    if (M[2]) { h += '<p class="rkm-rmsg-s">Ange alli\u00e9 du jour\u00a0: <a href="' + esc(M[3]) + '">' + esc(M[2]) + '</a></p>'; }
    h += '<p class="rkm-rmsg-s">Reviens demain pour un nouveau message.</p></div>';
    box.innerHTML = h;
  }
  function initRituel() {
    var cv = $('rkm-rit-cv'), btn = $('rkm-hold'), fg = $('rkm-hold-fg'), lbl = $('rkm-hold-lbl');
    if (!cv || !btn) { return; }
    var th = new Threads(cv, { tight: 1, turns: 5, spread: 0.24, sep: 0.26, amp: 0.22, lw: 2.2, sparks: 0.35, ease: 0.12 });
    var C = 276.5, prog = 0, holding = false, done = false, last = 0, lastBuzz = 0, loopOn = false;
    fg.style.strokeDashoffset = String(C);
    if (lsGet(RIT_KEY) === dayKey()) {
      done = true; prog = 1; th.target = 0; th.tight = 0;
      fg.style.strokeDashoffset = '0'; lbl.textContent = 'D\u00e9nou\u00e9 aujourd\u2019hui'; showRitMsg(true);
    }
    function loop(now) {
      if (!last) { last = now; }
      var dt = Math.min(48, now - last); last = now;
      if (!done) {
        if (holding) { prog = Math.min(1, prog + dt / 4800); }
        else { prog = Math.max(0, prog - dt / 1600); }
        th.target = 1 - prog;
        fg.style.strokeDashoffset = String(C * (1 - prog));
        if (holding && now - lastBuzz > 520) { lastBuzz = now; buzz(8 + Math.round(prog * 20)); }
        if (prog >= 1) {
          done = true; holding = false; rmClass(btn, 'rkm-holding');
          th.target = 0; th.burst(); buzz([40, 60, 40, 60, 120]);
          lbl.textContent = 'D\u00e9nou\u00e9 \u2713';
          lsSet(RIT_KEY, dayKey());
          showRitMsg(false);
        }
      }
      if (holding || (!done && prog > 0)) { window.requestAnimationFrame(loop); } else { loopOn = false; }
    }
    function down(e) {
      if (e && e.preventDefault) { e.preventDefault(); }
      if (done) { th.tight = 1; th.target = 0; th.burst(); buzz(30); return; }
      holding = true; addClass(btn, 'rkm-holding'); lbl.textContent = 'Respire\u2026 continue';
      if (!loopOn) { loopOn = true; last = 0; window.requestAnimationFrame(loop); }
    }
    function up() {
      if (!holding) { return; }
      holding = false; rmClass(btn, 'rkm-holding');
      if (!done) { lbl.textContent = 'Maintenir pour d\u00e9nouer'; }
      if (!loopOn) { loopOn = true; last = 0; window.requestAnimationFrame(loop); }
    }
    btn.addEventListener('mousedown', down);
    btn.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('mouseup', up);
    btn.addEventListener('touchend', up);
    btn.addEventListener('touchcancel', up);
    btn.addEventListener('mouseleave', up);
    btn.addEventListener('keydown', function (e) { if ((e.keyCode === 32 || e.keyCode === 13) && !holding) { down(e); } });
    btn.addEventListener('keyup', function (e) { if (e.keyCode === 32 || e.keyCode === 13) { up(); } });
    btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  /* ---------- Popup + inscription ---------- */
  var popMode = 'quiz', pendingDetail = null;
  function isLive() { return /(^|\.)astroya\.fr$/i.test(window.location.hostname) || /myshopify\.com$/i.test(window.location.hostname); }
  function initPop() {
    var pop = $('rkm-pop');
    if (!pop) { return; }
    if (pop.parentNode !== document.body) { document.body.appendChild(pop); }
    $('rkmp-x').addEventListener('click', closePop);
    pop.addEventListener('click', function (e) { if (e.target === pop) { closePop(); } });
    document.addEventListener('keydown', function (e) { if (e.keyCode === 27 && hasClass(pop, 'rkm-pop-show')) { closePop(); } });
    $('rkmp-form').addEventListener('submit', onSubmit);
    $('rkmp-done').addEventListener('click', function () {
      closePop();
      if (popMode === 'quiz' && pendingDetail) { showDetail(pendingDetail); pendingDetail = null; }
    });
    $('rkmp-email').addEventListener('change', function () { lsSet(EMAIL_KEY, $('rkmp-email').value || ''); });
    if (!isLive()) { $('rkmp-demo').hidden = false; }
    var nb = $('rkm-nl-btn');
    if (nb) {
      if (isUnlocked()) { setNlDone(); }
      nb.addEventListener('click', function () { openPop('nl'); });
    }
  }
  function setNlDone() {
    var t = $('rkm-nl-txt'), b = $('rkm-nl-btn');
    if (t) { t.textContent = 'Tu fais d\u00e9j\u00e0 partie de la communaut\u00e9 Astroya. Ta prochaine lettre arrive bient\u00f4t dans ta bo\u00eete mail.'; }
    if (b) { addClass(b, 'rkm-hide'); }
  }
  function openPop(mode) {
    popMode = mode;
    var pop = $('rkm-pop');
    $('rkmp-s1').className = 'rkmp-scr rkmp-cur';
    $('rkmp-s2').className = 'rkmp-scr';
    $('rkmp-err').innerHTML = '&#8203;';
    if (mode === 'quiz') {
      $('rkmp-eye').textContent = 'Analyse offerte';
      $('rkmp-t1').textContent = 'D\u00e9bloque ton analyse compl\u00e8te';
      $('rkmp-p1').textContent = 'Ta le\u00e7on \u00ab\u00a0' + (quiz.res ? quiz.res.name : '') + '\u00a0\u00bb en d\u00e9tail, et chaque semaine la lettre Astroya\u00a0: rituels, lunaisons et messages des anges.';
      $('rkmp-go').textContent = 'D\u00e9bloquer mon analyse';
      $('rkmp-done').textContent = 'Lire mon analyse';
      $('rkmp-p2').textContent = 'Ton analyse est d\u00e9bloqu\u00e9e. Tu recevras aussi la prochaine lettre Astroya dans ta bo\u00eete mail.';
    } else {
      $('rkmp-eye').textContent = 'La lettre Astroya';
      $('rkmp-t1').textContent = 'Rejoins la communaut\u00e9 Astroya';
      $('rkmp-p1').textContent = 'Lunaisons, rituels de lib\u00e9ration et guidance des anges, chaque semaine dans ta bo\u00eete mail.';
      $('rkmp-go').textContent = 'Je m\u2019inscris';
      $('rkmp-done').textContent = 'Fermer';
      $('rkmp-p2').textContent = 'Merci\u00a0! Ta premi\u00e8re lettre Astroya arrive bient\u00f4t dans ta bo\u00eete mail.';
    }
    var saved = lsGet(EMAIL_KEY);
    if (saved && !$('rkmp-email').value) { $('rkmp-email').value = saved; }
    pop.className = 'rkm-pop-show';
    setTimeout(function () { try { $('rkmp-email').focus(); } catch (e) { } }, 60);
  }
  function closePop() { $('rkm-pop').className = ''; }
  function onSubmit(e) {
    e.preventDefault();
    var email = ($('rkmp-email').value || '').replace(/^\s+|\s+$/g, ''), err = $('rkmp-err');
    lsSet(EMAIL_KEY, email);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Indique une adresse email valide, par exemple prenom@exemple.fr.'; return; }
    if (!$('rkmp-ok').checked) { err.textContent = 'Coche la case pour accepter de recevoir la newsletter.'; return; }
    err.innerHTML = '&#8203;';
    var btn = $('rkmp-go'), label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Un instant...';
    api({ action: 'subscribe', email: email, consent: true, answers: popMode === 'quiz' ? quiz.answers : [] }, function (d) {
      btn.disabled = false; btn.textContent = label;
      if (d && d.ok && d.token) {
        setToken(d.token);
        setNlDone();
        if (popMode === 'quiz' && d.detail) { pendingDetail = d.detail; if (quiz.res) { quiz.res.unlocked = true; quiz.res.detail = d.detail; } }
        $('rkmp-s1').className = 'rkmp-scr';
        $('rkmp-s2').className = 'rkmp-scr rkmp-cur';
        buzz(30);
        try { $('rkmp-done').focus(); } catch (x) { }
      } else {
        err.textContent = (d && d.error) ? d.error : 'L\u2019inscription n\u2019a pas pu aboutir. V\u00e9rifie ta connexion puis r\u00e9essaie.';
      }
    });
  }

  /* ---------- Apparition, lecture, images ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('.rkm-rv');
    if (!('IntersectionObserver' in window) || reduceMotion) { return; }
    addClass(root, 'rkm-js');
    var io = new IntersectionObserver(function (en) {
      for (var i = 0; i < en.length; i++) { if (en[i].isIntersecting) { addClass(en[i].target, 'rkm-in'); io.unobserve(en[i].target); } }
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var k = 0; k < els.length; k++) { io.observe(els[k]); }
  }
  function initReadBar() {
    var bar = document.createElement('div');
    bar.id = 'rkm-read'; bar.innerHTML = '<span>&#8203;</span>';
    document.body.appendChild(bar);
    var s = bar.firstChild, root = $('rkm'), tk = false;
    function upd() {
      tk = false;
      var r = root.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - vh)));
      s.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; window.requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }
  function initImgs(root) {
    var imgs = root.querySelectorAll('.rkm-prod-img img,.rkm-pcta-img img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].addEventListener('error', function (e) { addClass(e.currentTarget.parentNode, 'rkm-noimg'); });
    }
  }

  function boot() {
    var root = $('rkm');
    if (!root || window.__astroyaRkmBoot) { return !!root; }
    window.__astroyaRkmBoot = true;
    var steps = [initPop, initHero, initSigns, initTimeline, initQuiz, initFinder, initRituel, initReadBar];
    for (var i = 0; i < steps.length; i++) { try { steps[i](); } catch (e) { } }
    try { initReveal(root); initImgs(root); } catch (e) { }
    return true;
  }
  var tries = 0;
  var iv = setInterval(function () { tries++; if (boot() || tries >= 40) { clearInterval(iv); } }, 120);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (boot()) { mo.disconnect(); } });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();
} catch(error){console.error(error);}